import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useAnalytics } from '@/hooks/analytics';
import { useApi } from '@/hooks/api';
import { calmLogger } from '@/utils/calmLogger';

import { useFaves } from './useFaves';

interface UseProgramFavorite {
	(id?: string): {
		isFaved: boolean;
		setIsFaved: Dispatch<SetStateAction<boolean>>;
		toggleFavorite: () => void;
	};
}

export const useProgramFavorite: UseProgramFavorite = id => {
	const apiRequest = useApi();
	const { logEvent } = useAnalytics();
	const { faves, mutate } = useFaves();
	const [isFaved, setIsFaved] = useState(false);

	useEffect(() => {
		if (!id) {
			return;
		}

		const isProgramFaved = Array.isArray(faves)
			? faves.filter(fave => fave.program_id === id).some(fave => 'faved_at' in fave)
			: false;

		setIsFaved(isProgramFaved);
	}, [faves, id]);

	const toggleFavorite = async () => {
		if (!id) {
			return;
		}

		const addToFaves = !isFaved;
		setIsFaved(addToFaves);

		try {
			await apiRequest({
				endpoint: 'faves',
				method: addToFaves ? 'POST' : 'DELETE',
				body: {
					program_id: id,
				},
			});

			logEvent({
				eventName: 'Fave Button : Fave : Posted',
				eventProps: {
					program_title: id,
				},
			});

			await mutate();
		} catch (err) {
			calmLogger.error('Error favoriting content', {}, err);
		}
	};

	return {
		isFaved,
		setIsFaved,
		toggleFavorite,
	};
};
